import React from 'react';
import { connect } from 'react-redux';
import { selectIsWindowMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { selectNameByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftSceneOptions } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { TextVariableInput } from '@gift-variable-plugins/text-shared/TextVariableInput';
import { selectHasNonRegularStyleById, selectInputById } from './_redux';
import { TextInputControlMobile } from './partials/TextInputControlMobile';
import { TextInputControlPanel } from './partials/TextInputControlPanel';

const _TextInputControl = (props: TextInputControlProps) => {
    const isMobile = useMobile();
    if (isMobile) {
        return (
            <TextInputControlMobile {...props} />
        );
    } else {
        return (
            <TextInputControlPanel {...props} />
        );
    }
};

export type TextInputControlProps = {
    variableIds: string[];
    name: string;
    input: TextVariableInput;
    hasFontStyling: boolean;
    isWindowMode: boolean;
    isContentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])!,
    hasFontStyling: selectHasNonRegularStyleById(state, ownProps.variableIds[0])!,
    input: selectInputById(state, ownProps.variableIds[0])!,
    isWindowMode: selectIsWindowMode(state),
    isContentFirst: (state.scene.options as GiftSceneOptions)?.contentFirst ?? false
});

export const TextInputControl = connect(
    mapStateToProps
)(_TextInputControl);